export const PACKAGE_TYPES = {
    PAPER_TRADING: 0,
    LIVE_TRADING: 1,
    BACKTESTING: 2,
};